<div class="d-flex align-items-stretch">
    <!-- Logo -->
    <a class="logo d-flex align-items-center justify-content-center bg-primary me-7 me-lg-10" [routerLink]="['/', currentLang]">
        <img class="img-fluid" src="/assets/images/logo-stelmach.svg" alt="Stelmach" />
    </a>
    <div class="d-flex flex-column flex-grow-1">
        <!-- Menu -->
        <div class="flex-grow-1">
            <ul class="d-flex h-100 align-items-center menu" [class.menu-main-page]="isMainPage">
                @for (item of menuItems; track item; let last = $last) {
                    <li [ngClass]="{ 'me-lg-8 me-4': !last, 'me-auto': last }">
                        <a [routerLink]="item.url | localize" routerLinkActive="active" class="font-secondary text-hover-primary fs-14 fw-600">
                            {{ item.name | translate }}
                        </a>
                    </li>
                }
            </ul>
        </div>
    </div>
</div>
